import React from 'react';

import {
  AddConsultantButton,
  AddIcon,
  BackFullIcon,
  CheckIcon,
  CloseIcon,
  Container,
  Content,
  DateFilterArea,
  DateInput,
  DateLabel,
  Header,
  HeaderActions,
  HeaderBack,
  HeaderInfo,
  HeaderTitle,
  LoadRow,
  MatchCard,
  MatchCardClickArea,
  MatchContainer,
  MatchDescriptionRow,
  MatchDescriptionText,
  MatchPhoto,
  NextPageButton,
  PaginationArea,
  PreviousPageButton,
} from './styles';

import Load from 'components/load';
import Search from 'components/search';
import MenuBar from 'components/menu-bar';
import WarnModal from 'components/modais/warn';
import MatchModal from 'components/modais/match';
import ResponsiveContainer from 'components/container';

import { toast } from 'react-toastify';
import { useTheme } from 'styled-components';
import { MatchCRUD } from 'services/requests/matchs';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import MatchCRUDProps, {
  MatchData,
} from 'services/requests/matchs/index.d';
import SendPdfModal from 'components/modais/send-pdf';

const matchCRUD = new MatchCRUD();

const MatchsPage: React.FC = () => {
  const { id } = useParams();
  const { colors } = useTheme();
  const navigation = useNavigate()

  const location = useLocation();
  const { vacancy, personalClient } = location.state || {};
  
  // Ref
  const currentPage = React.useRef(1);

  // States
  const [search, setSearch] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  
  const [matchData, setMatchData] = React.useState<MatchCRUDProps.readReturn>();
  const [currentMatch, setCurrentMatch] = React.useState<MatchData>();

  const [showModal, setShowModal] = React.useState(false);
  const [showWarnModal, setShowWarnModal] = React.useState(false);
  const [showPdfModal, setShowPdfModal] = React.useState(false);

  const [initialDate, setInitialDate] = React.useState('')
  const [endDate, setEndDate] = React.useState('')

  // Callbacks
  const getMatchs = React.useCallback(async (page?: number, dateInit?: string, dateEnd?: string) => {
    try {
      setLoading(true);
      if(dateInit && !isValidDate(dateInit)) throw new Error('Digite uma data inicial válida.')
      if(dateEnd && !isValidDate(dateEnd)) throw new Error('Digite uma data final válida.')
        
      currentPage.current = page || 1;

      const { data, status, error } = await matchCRUD.read({
        page,
        per_page: 10,
        personal_client_id: personalClient && (Number(id) || Number(personalClient.id)),
        vacancy_id: vacancy && (Number(id) || Number(vacancy.id)),
        updated_at_end: dateEnd,
        updated_at_start: dateInit,
      });

      if (error) throw new Error('Ocorreu um erro na listagens dos matchs. (2)');
      

      if (status === 200 && data) {
        setMatchData(data);
      }
    } catch (e) {
      const { message } = e as Error
      toast.error(message)
    } finally {
      setLoading(false);
    }
  }, []);

  const deleteMatch = React.useCallback(async (id: number) => {
    try {
      const { status, error } = await matchCRUD.delete({ id });

      if (error) throw new Error('Erro ao deletar usuario.');

      if (status === 200) {
        toast('Match deletado com sucesso.');
        getMatchs();
      }
    } catch (e) {
      toast(e as String);
    }
  }, []);

  const currentData = React.useMemo(() => {
    if (search) {
      let currentFilter = search.toLocaleLowerCase();
      return matchData?.VacancyMatch?.filter(
        e =>
          e.personal_client_relation.name
            .toLowerCase()
            .includes(currentFilter) ||
          e.advisor_relation.name.toLowerCase().includes(currentFilter),
      );
    }
    return matchData?.VacancyMatch;
  }, [matchData, search]);

  React.useEffect(() => {
    getMatchs();
  }, []);

  React.useEffect(() => {
      if(initialDate.length === 10 && endDate.length === 10) {
        if(isValidDate(initialDate) && isValidDate(endDate)) {
          getMatchs(undefined, initialDate, endDate);
          return;
        }
      }
      if(initialDate.length === 10) {
        if (isValidDate(initialDate)) {
          getMatchs(undefined, initialDate);
        }
      }
      if(endDate.length === 10) {
        if (isValidDate(endDate)) {
          getMatchs(undefined, undefined, endDate);
        }
      }
      
  }, [initialDate, endDate])

  return (
    <Container>
      <MenuBar />
      <Content>
        <ResponsiveContainer>
          <Header>
            <HeaderBack onClick={() => navigation('/vagas')}>
              <BackFullIcon />
            </HeaderBack>
            <HeaderInfo>
              <HeaderTitle>Todos matchs {vacancy && ` vaga : ${vacancy.name}`}{personalClient && `cliente : ${personalClient.name}`}</HeaderTitle>
              <HeaderActions>
                {/* <Search
                  value={search}
                  setValue={setSearch}
                  placeholder="Pesquisar match"
                /> */}
               
                <AddConsultantButton
                  title="Criar match"
                  iconRight={AddIcon}
                  callback={() => setShowModal(true)}
                />
              </HeaderActions>
            </HeaderInfo>
          </Header>
          <MatchContainer>
             <DateFilterArea>
                <DateLabel>data inicial:</DateLabel>
                <DateInput 
                  name='initialDate' 
                  value={initialDate}
                  onChange={e => setInitialDate(e.target.value)}
                />
                <DateLabel>data final:</DateLabel>
                <DateInput 
                  name='endDate' 
                  value={endDate}
                  onChange={e => setEndDate(e.target.value)}
                />
            </DateFilterArea>
            
            <MatchDescriptionRow>
              <MatchDescriptionText style={{ flex: 3 }}>
                {vacancy && 'Cliente'}{personalClient && 'Vaga'}
              </MatchDescriptionText>
              <MatchDescriptionText style={{ flex: 4 }}>
                Consultor
              </MatchDescriptionText>
              <MatchDescriptionText style={{ flex: 3 }}>
                Criado em
              </MatchDescriptionText>
              <MatchDescriptionText style={{ flex: 0 }}>
                Status
              </MatchDescriptionText>
            </MatchDescriptionRow>

            {loading ? (
              <LoadRow>
                <Load
                  customStyle={{
                    color: colors.secondaryDark,
                  }}
                  size="extraLarge"
                />
              </LoadRow>
            ) : (
              <>
                {currentData && currentData?.length > 0 ? (
                  currentData?.map((e, i) => {
                    if(vacancy) {
                      return (
                        <MatchCard key={i}>
                          <MatchCardClickArea
                            onClick={() => {
                              setCurrentMatch(e);
                              setShowModal(true);
                            }}>
                            <MatchPhoto
                              src={
                                e.personal_client_relation.image ||
                                require('assets/images/user-temporary.webp')
                              }
                            />
                            <MatchDescriptionText style={{ flex: 3 }}>
                              {e.personal_client_relation.name}
                            </MatchDescriptionText>
                            <MatchPhoto
                              src={
                                e.advisor_relation.image ||
                                require('assets/images/user-temporary.webp')
                              }
                            />
                            <MatchDescriptionText style={{ flex: 4 }}>
                              {e.advisor_relation.name}
                            </MatchDescriptionText>
                            <MatchDescriptionText style={{ flex: 3.5 }}>
                              {e.created_at}
                            </MatchDescriptionText>
                          </MatchCardClickArea>
                          {e.authorized ? <CheckIcon /> : <CloseIcon />}
                        </MatchCard>
                      );
                    } else if (personalClient) {
                      return (
                        <MatchCard key={i}>
                          <MatchCardClickArea
                            onClick={() => {
                              setCurrentMatch(e);
                              setShowModal(true);
                            }}>
                            <MatchDescriptionText style={{ flex: 3.2 }}>
                              {e.vacancy_relation.vacancy_name}
                            </MatchDescriptionText>
                            <MatchPhoto
                              src={
                                e.advisor_relation.image ||
                                require('assets/images/user-temporary.webp')
                              }
                            />
                            <MatchDescriptionText style={{ flex: 4 }}>
                              {e.advisor_relation.name}
                            </MatchDescriptionText>
                            <MatchDescriptionText style={{ flex: 3.5 }}>
                              {e.created_at}
                            </MatchDescriptionText>
                          </MatchCardClickArea>
                          {e.authorized ? <CheckIcon /> : <CloseIcon />}
                        </MatchCard>
                      );
                    }
                    return <HeaderTitle>Erro na busca...</HeaderTitle>
                  })
                ) : (
                  <HeaderTitle>Nenhum match encontrado...</HeaderTitle>
                )}
                <PaginationArea>
                  {matchData?.has_prev && (
                    <PreviousPageButton
                      title="Voltar Página"
                      callback={() => getMatchs(currentPage.current - 1, initialDate, endDate)}
                    />
                  )}
                  {matchData?.has_next && (
                    <NextPageButton
                      title="Proxima Página"
                      callback={() => getMatchs(currentPage.current + 1, initialDate, endDate)}
                    />
                  )}
                </PaginationArea>
              </>
            )}
          </MatchContainer>
        </ResponsiveContainer>
      </Content>
      {showModal && (
        <MatchModal
          onClose={() => {
            setCurrentMatch(undefined);
            setShowModal(false);
            getMatchs();
          }}
          onDelete={() => setShowWarnModal(true)}
          onAccept={() => setShowPdfModal(true)}
          match={currentMatch}
          personalClientId={personalClient?.id}
          vacancyId={vacancy?.id}
        />
      )}
      {showWarnModal && (
        <WarnModal
          title="Apagar Match"
          description="Tem certeza que deseja apagar esse match ?"
          declineButtonTitle='Não, manter.'
          confirmButtonTitle='Sim, remover.'
          declineCallback={() => setShowWarnModal(false)}
          confirmCallback={() => {
            deleteMatch(currentMatch?.id || 0);
            setCurrentMatch(undefined);
            setShowWarnModal(false);
            setShowModal(false);
            getMatchs();
          }}
        />
      )}
      {showPdfModal && (
        <SendPdfModal type='personal_client' match={currentMatch} onClose={() => setShowPdfModal(false)} 
        onSend={() => {
          setShowPdfModal(false)
          setCurrentMatch(undefined);
          setShowModal(false);
          getMatchs();
        }}/>
      )}
    </Container>
  );
};

export default MatchsPage;


const isValidDate = (dateString: string) => {
  const regex = /^(201[2-9]|20[2-9][0-9])-\d{2}-\d{2}$/;
  if (!regex.test(dateString)) return false;

  const [year, month, day] = dateString.split('-').map(Number);

  const date = new Date(year, month - 1, day);
  return (
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day
  );
};